import { DiagramEditorSettings } from '../../interfaces/diagram-editor/diagram-editor-settings.interface';

export const DiagramEditorConfig: DiagramEditorSettings = {
  simpleView: true,
  zoomLevel: 1
};
